import { render, staticRenderFns } from "./catalogIntroduce.vue?vue&type=template&id=678a8424&scoped=true&"
import script from "./catalogIntroduce.vue?vue&type=script&lang=js&"
export * from "./catalogIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./catalogIntroduce.vue?vue&type=style&index=0&id=678a8424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678a8424",
  null
  
)

export default component.exports